// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__2HGc_","imglink":"Layout_imglink__17_Uy","centerLogo":"Layout_centerLogo__7iYMJ","imgbtn":"Layout_imgbtn__i-cTv"};